<script setup lang="ts">
import { computed } from 'vue';

import { dialog } from '@/components/modal/modal';
import { loadSvgMap, useFilters } from '@/elements';
import { capitalizeFirstLetter } from '@/helpers';
import { alternative, form } from '..';

import Alternative from '../components/AlternativeAccomodations.vue';
import AlternativeFlights from '../components/AlternativeFlights.vue';
import CurrentFlight from '../components/CurrentFlight.vue';

import type { Book } from '@/types/book';

const props = defineProps<{ booking: Book }>();

const { show } = useFilters();

const { scrollTo } = window;

function saveAlternativeSelection() {
  alternative.value = false;
  scrollTo({ top: 0, behavior: 'smooth' });
}

const [AlternativeAccomodations, showAlternativeAccomodations] = dialog(async () => Alternative);

const included = computed(() => [
  ...props.booking!.pricing.included.slice(0, 1),
  {
    title: 'Gratis eigen ski’s mee',
    text: 'Inclusief extra stuk ruimbagage om eigen wintersportuitrusting mee te nemen.',
    type: 'skis',
  },
  ...props.booking!.pricing.included.slice(1, props.booking!.pricing.included.length),
]);

const persons = computed(() => {
  if (!props.booking) return 0;
  const { adults, children } = props.booking.pricing.persons;
  return parseInt(adults) + parseInt(children);
});
</script>

<template>
  <template v-if="alternative">
    <template v-for="(alternatives, index) in booking?.pricing.flights" :key="index">
      <AlternativeFlights :flight="alternatives" :current="booking?.pricing.flight" />
    </template>
    <button class="button" @click="saveAlternativeSelection">selectie opslaan</button>
  </template>
  <template v-else>
    <CurrentFlight :flight="booking?.pricing.flight" />

    <!-- <div class="block text-right margin">
            <button @click="alternative = true" class="button flights">Alternatieve vluchten</button>
        </div> -->

    <div class="block block--usps">
      <ul>
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path stroke="#1A4C8D" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18 8-7 7-4-4" />
          </svg>
          Inclusief één stuk ruimbagage (23 kilo).
        </li>
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path stroke="#1A4C8D" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18 8-7 7-4-4" />
          </svg>
          Inclusief extra stuk ruimbagage om eigen wintersportuitrusting mee te nemen.
        </li>
        <li>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path stroke="#1A4C8D" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18 8-7 7-4-4" />
          </svg>
          De getoonde tijden zijn lokale tijden
        </li>
      </ul>
    </div>
    <div class="block margin">
      <h3 class="block__title">Accommodatie</h3>
    </div>
    <div class="block block--list">
      <ul>
        <li>
          <span>Naam</span>
          <span>{{ capitalizeFirstLetter(booking.accommodation.name) }}</span>
          <span></span>
        </li>
        <li>
          <span>Type kamer</span>
          <span>{{ capitalizeFirstLetter(booking.pricing.room.room.name) }}</span>
          <span><button @click="showAlternativeAccomodations()" class="button flights">Alternatieve kamer</button></span>
        </li>
        <li>
          <span>Aantal overnachtingen</span>
          <span>{{ booking.pricing.duration }} nachten</span>
          <span></span>
        </li>
        <li>
          <span>Reisgezelschap</span>
          <span>{{ Number(booking.pricing.persons.adults) + Number(booking.pricing.persons.children) }} personen</span>
          <span></span>
        </li>
      </ul>
    </div>
    <div class="block block--inclusive margin-big">
      <h4 class="block__title">Inclusief bij deze reis</h4>
      <ul class="block__items">
        <li v-for="item in included" :key="item.title">
          <img :src="loadSvgMap[item.type]" />
          <span>
            <p>{{ item.title }}</p>
            <p>{{ item.text }}</p>
          </span>
        </li>
      </ul>
    </div>
    <div class="block block--form margin">
      <h3 class="block__title">Extra's</h3>
      <div class="block__check">
        <input type="checkbox" id="extra" name="extra" v-model="form.carrental" />
        <label for="extra">
          <p>Ik wil graag een vrijblijvende prijsopgave voor een huurauto in Jasper</p>
        </label>
      </div>
    </div>
  </template>

  <AlternativeAccomodations
    :accommodations="booking.pricing.rooms"
    :current="booking.pricing.room"
    :persons
    v-model:form="form"
    @update:form="show(true, true)"
  />
</template>
